import type { VoidFunctionComponent } from 'react';

import { QUALITY_ISSUE_TYPE_LABELS, QUALITY_ISSUE_TYPES, type QualityIssueType } from '../../../shared/issuesV2';
import { selectOptionFactory } from '../../utils';

import { Select } from '.';

export type Props = {
  onChange: (qualityIssueType?: QualityIssueType) => void;
  selectedQualityIssueType?: QualityIssueType;
};

const qualityRuleSelectOptions = QUALITY_ISSUE_TYPES.map(
  (option) => selectOptionFactory(option, QUALITY_ISSUE_TYPE_LABELS[option]),
);

/**
 * A generic select input for choosing a quality issue type from the list of all quality issue types.
 */
const QualityIssueOptions: VoidFunctionComponent<Props> = ({ onChange, selectedQualityIssueType }) => {
  return (
    <Select
      id="quality-issue-options-dropdown"
      placeholder="Select a quality issue type..."
      options={qualityRuleSelectOptions}
      filterOption={null}
      value={selectedQualityIssueType ? selectOptionFactory(selectedQualityIssueType) : undefined}
      onChange={(newValue) => onChange(newValue?.value)}
      isClearable
    />
  );
};

export default QualityIssueOptions;
